class OfflineModeSelectorController {
  constructor(
    APIService,
    LogService
  ) {
    "ngInject";
    this.APIService = APIService;
    this.LogService = LogService;
    this._isOfflineMode = this.APIService.isOfflineMode;
  }

  get disabled() {
    return !this.APIService.isDeviceOnline;
  }

  set isOfflineMode(value) {
    this._isOfflineMode = value;
    this.APIService.isOfflineMode = value;
  }

  get isOfflineMode() {
    if (!this.APIService.isDeviceOnline) {
      // Always show as offline if device is offline
      return true;
    } else {
      return this._isOfflineMode;
    }
  }

  get dropdownButtonTextKey() {
    return this.isOfflineMode ? 'OFFLINE' : 'ONLINE';
  }
}

export default OfflineModeSelectorController;
